export default __webpack_public_path__ + "static/media/icons-trust-portal.3b5877c7.svg";